import * as React from 'react'

import { Box, Spinner, Table } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useIncidences } from 'modules/bookkeepers/hooks/IncidencesContext'
import { useIncidenceTaskTypes } from 'modules/bookkeepers/hooks/TaskTypesContext'
import { useIncidenceFilterContext } from 'modules/bookkeepers/lib/IncidenceFilterContext'

import List from './List'

interface BodyProps {
  selectedIncidence: string | null | undefined
  loading: boolean
  onRowSelectPath: (incidenceId: string, isReopened: boolean) => string
  showIncidenceTypeColumn?: boolean
  showIncidencePayrollIntegrationStatus: boolean
  selectableIncidenceIds?: Set<string>
  selectedIncidencesId?: Set<string>
  onToggleIncidence?: (id: string) => void
}

const Body = ({
  selectedIncidence,
  loading,
  onRowSelectPath,
  showIncidenceTypeColumn = true,
  showIncidencePayrollIntegrationStatus,
  selectableIncidenceIds,
  selectedIncidencesId,
  onToggleIncidence,
}: BodyProps) => {
  const incidences = useIncidences() || []
  const { page, hasMore, setHasMore, onPageChange } = useIncidenceFilterContext()
  const taskTypes = useIncidenceTaskTypes()
  const checkboxLength = onToggleIncidence ? 1 : 0
  const previousTotalRef = React.useRef(0)

  if (!loading && incidences.length === previousTotalRef.current) {
    setHasMore(false)
  } else if (!loading) {
    setHasMore(true)
  }

  React.useEffect(() => {
    previousTotalRef.current = incidences.length
  }, [incidences.length])

  const colSpan = 7 + taskTypes.length + checkboxLength

  return (
    <Table.BodyWithInfiniteScroll
      key={page}
      page={page}
      hasMore={!loading && hasMore}
      loadMore={onPageChange}
      colSpan={colSpan}
    >
      {loading && !incidences?.length ? (
        <Table.Row>
          <Table.Cell colSpan={colSpan}>
            <Box alignItems="center">
              <Spinner />
            </Box>
          </Table.Cell>
        </Table.Row>
      ) : (
        <List
          incidences={incidences}
          selectedIncidence={selectedIncidence}
          onRowSelectPath={onRowSelectPath}
          loading={loading}
          colSpan={colSpan}
          showIncidenceTypeColumn={showIncidenceTypeColumn}
          showIncidencePayrollIntegrationStatus={showIncidencePayrollIntegrationStatus}
          selectableIncidenceIds={selectableIncidenceIds}
          selectedIncidencesId={selectedIncidencesId}
          onToggleIncidence={onToggleIncidence}
        />
      )}
    </Table.BodyWithInfiniteScroll>
  )
}

export default observer(Body)
